import React,{createContext,useState,useEffect} from "react";
import axiosInstance from "../utils/axiosInstance";
import { API_PATHS } from "../utils/apiPaths";


export const UserContext = createContext()

const UserProvider = ({children}) => {
    const [user,setUser]= useState('')
    const [loading,setLoading]= useState(true);//nouvel etat pour traquer le chargement
    useEffect(()=>{
        if(user) return;

        const accessToken = localStorage.getItem("token")
        if(!accessToken){
            setLoading(false);
            return
        }

        const fetchUser = async ()=> {
            try {
                const response = await axiosInstance.get(API_PATHS.AUTH.GET_PROFILE)
                setUser(response.data)
            } catch (error) {
                console.error("Utilisateur non authentifier",error)
                clearUser();
            }finally{
                setLoading(false)

            }
        }
        fetchUser()
    },[])

    const updateUser = (userData) => {
        setUser(userData)
        localStorage.setItem("token",userData.token)// enregistrement du token 
        setLoading(false)
    }

    const clearUser = ()=>{
        setUser(null);
        localStorage.removeItem("token")
    }
    return (<UserContext.Provider value={{user,loading,updateUser,clearUser}}>{children}</UserContext.Provider>)
}


export default UserProvider